document.addEventListener("alpine:init", () => {
    Alpine.data('dynamicProductCarousel', (images) => {
        return {
            dynamicImages: [],
            defaultImages: images || [],
            renderedImages: [],
            carousel: null,
            carouselThumbnails: null,

            /*
            * Initialize the alpine component
            */
            init() {
                const url = new URL(window.location.href);
                const searchParams = new URLSearchParams(url.search);
                const productId = Number(searchParams.get('selected_product'));

                this.renderedImages = this.defaultImages;

                if (productId) {
                    this.renderedImages = window.bundleProducts.find(product => product.productId === productId).media || this.defaultImages;
                }
            },

            /*
            * Initialize the dynamic product carousel
            */
            initDynamicCarousel() {
                if (!this.renderedImages || this.renderedImages.length === 0) {
                    return;
                }

                if (this.carousel) {
                    this.carousel.destroy();
                }

                if (this.carouselThumbnails) {
                    this.carouselThumbnails.destroy();
                }

                const carouselPlugins = [];
                if (this.renderedImages.length > 1) {
                    carouselPlugins.push(this.navigation);
                }

                this.carousel = new KeenSlider(this.$refs.carousel, {
                    loop: true,
                    slides: {
                        origin: 'center',
                    },
                },
                carouselPlugins
                );

                this.carouselThumbnails = new KeenSlider(this.$refs.carouselThumbnails, {
                    initial: 0,
                    vertical: true,
                    disabled: this.renderedImages.length < 5,
                    loop: true,
                    slides: {
                        perView: 5,
                        spacing: 20,
                    },
                },
                [this.ThumbnailPlugin(this.carousel)]
                );
            },

            /*
            * Update the carousel when a selected product is changed
            * @param {Object} $event - The event object
            */
            updateCarousel($event) {
                const productId = $event.detail?.productId || null;
                if (!productId) {
                    this.renderedImages = this.defaultImages;
                    return;
                }

                this.renderedImages = window.bundleProducts.find(product => product.productId === productId).media || this.defaultImages;
            },

            /*
            * Thumbnail plugin for the dynamic product carousel
            * @param {Object} main - The main slider
            * @returns {Function} - The thumbnail plugin
            */
            ThumbnailPlugin(main) {
                return (slider) => {
                function removeActive() {
                    slider.slides.forEach((slide) => {
                    slide.classList.remove('active');
                    });
                }
                function addActive(idx) {
                    slider.slides[idx].classList.add('active');
                }

                function addClickEvents() {
                    slider.slides.forEach((slide, idx) => {
                    slide.addEventListener('click', () => {
                        main.moveToIdx(idx);
                    });
                    });
                }

                slider.on('created', () => {
                    addActive(slider.track.details.rel);
                    addClickEvents();
                    main.on('animationStarted', (main) => {
                    removeActive();
                    const next = main.animator.targetIdx || 0;
                    addActive(main.track.absToRel(next));
                    slider.moveToIdx(Math.min(slider.track.details.maxIdx, next));
                    });
                });
                };
            },

            /*
            * Navigation for the dynamic product carousel
            * @param {Object} slider - The slider
            */
            navigation(slider) {
                let wrapper, dots, arrowLeft, arrowRight;
                function markup(remove) {
                    wrapperMarkup(remove);
                    dotMarkup(remove);
                    arrowMarkup(remove);
                }

                function removeElement(elment) {
                    elment.parentNode.removeChild(elment);
                }
                function createDiv(className) {
                    var div = document.createElement('div');
                    var classNames = className.split(' ');
                    classNames.forEach((name) => div.classList.add(name));
                    return div;
                }

                function arrowMarkup(remove) {
                    if (remove) {
                        removeElement(arrowLeft);
                        removeElement(arrowRight);
                        return;
                    }
                    arrowLeft = createDiv('arrow arrow--left');
                    arrowLeft.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M15 7C15 7.55228 14.5523 8 14 8L2 8C1.44772 8 1 7.55228 1 7C1 6.44771 1.44772 6 2 6L14 6C14.5523 6 15 6.44771 15 7Z" fill="white"></path> <path d="M7.70711 0.292893C8.09763 0.683417 8.09763 1.31658 7.70711 1.70711L2.41421 7L7.70711 12.2929C8.09763 12.6834 8.09763 13.3166 7.70711 13.7071C7.31658 14.0976 6.68342 14.0976 6.29289 13.7071L0.292893 7.70711C-0.0976311 7.31658 -0.097631 6.68342 0.292893 6.29289L6.29289 0.292893C6.68342 -0.0976311 7.31658 -0.0976311 7.70711 0.292893Z" fill="white"></path></svg>';
                    arrowLeft.addEventListener('click', () => slider.prev());
                    arrowLeft.appendChild(createDiv('arrow--icon'));
                    arrowRight = createDiv('arrow arrow--right');
                    arrowRight.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M1 7C1 7.55228 1.44772 8 2 8L14 8C14.5523 8 15 7.55228 15 7C15 6.44771 14.5523 6 14 6L2 6C1.44772 6 1 6.44771 1 7Z" fill="white"></path> <path d="M8.29289 0.292893C7.90237 0.683417 7.90237 1.31658 8.29289 1.70711L13.5858 7L8.29289 12.2929C7.90237 12.6834 7.90237 13.3166 8.29289 13.7071C8.68342 14.0976 9.31658 14.0976 9.70711 13.7071L15.7071 7.70711C16.0976 7.31658 16.0976 6.68342 15.7071 6.29289L9.70711 0.292893C9.31658 -0.0976311 8.68342 -0.0976311 8.29289 0.292893Z" fill="white"></path> </svg>';
                    arrowRight.addEventListener('click', () => slider.next());
                    arrowRight.appendChild(createDiv('arrow--icon'));

                    wrapper.appendChild(arrowLeft);
                    wrapper.appendChild(arrowRight);
                }

                function wrapperMarkup(remove) {
                    if (remove) {
                        var parent = wrapper.parentNode;
                        while (wrapper.firstChild) parent.insertBefore(wrapper.firstChild, wrapper);
                        removeElement(wrapper);
                        return;
                    }
                    wrapper = createDiv('navigation-wrapper');
                    slider.container.parentNode.appendChild(wrapper);
                    wrapper.appendChild(slider.container);
                }

                function dotMarkup(remove) {
                    if (remove) {
                        removeElement(dots);
                        return;
                    }
                    dots = createDiv('dots');
                    slider.track.details.slides.forEach((_e, idx) => {
                        var dot = createDiv('dot');
                        dot.addEventListener('click', () => slider.moveToIdx(idx));
                        dots.appendChild(dot);
                    });
                    wrapper.appendChild(dots);
                }

                function updateClasses() {
                    var slide = slider.track.details.rel;
                    slide === 0 ? arrowLeft.classList.add('arrow--disabled') : arrowLeft.classList.remove('arrow--disabled');
                    slide === slider.track.details.slides.length - 1
                        ? arrowRight.classList.add('arrow--disabled')
                        : arrowRight.classList.remove('arrow--disabled');
                    Array.from(dots.children).forEach(function (dot, idx) {
                        idx === slide ? dot.classList.add('dot--active') : dot.classList.remove('dot--active');
                    });
                }

                slider.on('created', () => {
                    markup();
                    updateClasses();
                });
                slider.on('optionsChanged', () => {
                    markup(true);
                    markup();
                    updateClasses();
                });
                slider.on('slideChanged', () => {
                    updateClasses();
                });
                slider.on('destroyed', () => {
                    markup(true);
                });
            }
        }
    });
});